import React from 'react'

const Emoji = ({ symbol, size = 16, label }) => (
  <span
    className="emoji"
    role="img"
    style={{ fontSize: size }}
    aria-label={label ? label : ''}
    aria-hidden={label ? 'false' : 'true'}
  >
    {symbol}
  </span>
)

export default Emoji
